import PropTypes from 'prop-types';

import { useState, useEffect } from 'react';

function Breadcrumb({ title }) {
    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const header = document.getElementById('header-site');
        if (!header) return;
    
        const updateHeight = () => {
            setHeaderHeight(header.offsetHeight);
        };
    
        // Follow initial height header
        updateHeight();
    
        // Follow resize header
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header);
    
        // Follow resize window
        window.addEventListener('resize', updateHeight);
    
        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);
    return (
        <div className="bres-cus" 
            style={{ position: 'sticky', zIndex: 50, top: `${headerHeight}px`, left: '0', width: '100%', backgroundColor: '#FFF'}}>
            <div className="container">
                <ul>
                    <li>
                        <a href="/"><img src="/images/icon-home.png" alt="" /></a> 
                    </li>
                    <li className="dash">\</li>
                    <li>{title}</li>
                </ul>
            </div>
        </div>
    )
}

Breadcrumb.propTypes = {
    title: PropTypes.string.isRequired
}

export default Breadcrumb;